import React from "react";
import ImageWall from "../components/imageWall/imageWall";
import Header from "../components/header/header";
import FormFive from "../components/form/formFive/formFive";
import { useLocation } from "react-router-dom";

const CreditFive = () => {
  const location = useLocation();
  const user = location.state;
  return (
    <ImageWall>
      <Header
        title="Bienvenido a préstamo online"
        text="Suba las siguientes imágenes solicitadas a continuación. Por favor tenga en cuenta Solo se permiten imágenes en formato PNG , JPEG o PDF"
      />
      <FormFive userFive={user} />
    </ImageWall>
  );
};

export default CreditFive;
